export function getSpaceThreadUrl({ threadSlug, isComputerThread, isArticleThread, isNewThread, }) {
    if (isArticleThread) {
        return canonicalizeLegacyPermalinkPath(`/page/${threadSlug}`);
    }
    if (isComputerThread) {
        return canonicalizeLegacyPermalinkPath(`/computer/tasks/${threadSlug}`);
    }
    if (isNewThread) {
        return canonicalizeLegacyPermalinkPath(`/search/new/${threadSlug}`);
    }
    return canonicalizeLegacyPermalinkPath(`/search/${threadSlug}`);
}
import { canonicalizeLegacyPermalinkPath } from '#pplx/frontend/apps/ask/permalink-slug/canonicalizeLegacyPermalink.js';
//# sourceMappingURL=threadUtils.js.map